// What Premium costs and how the trial works, in one place (#325).
//
// New subscribers get a 3-day free trial with the card collected up front, then
// pay $9.99/month. People who subscribed before 2026-09-19 keep $4.99; that is a
// Stripe price on their subscription, not something the site decides. The amount
// here must match the Stripe Price behind `stripe.price.premium`, and the trial
// length must match `stripe.trial.days` on the backend.
export const PREMIUM_PRICE = "$9.99";
export const PREMIUM_PRICE_PER_MONTH = `${PREMIUM_PRICE}/month`;
export const TRIAL_DAYS = 3;
export const TRIAL_CTA = `Start ${TRIAL_DAYS}-Day Free Trial`;

// Shown next to every trial button. A card-up-front trial has to say, before the
// click, what will be charged, when, and how to avoid it.
export const TRIAL_TERMS =
    `Free for ${TRIAL_DAYS} days, then ${PREMIUM_PRICE_PER_MONTH}. ` +
    "Cancel before the trial ends and you won't be charged.";
